/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */

module.exports = (function() {
    'use strict';

    var ErrorItemView = Backbone.View.extend({
        tagName: 'li',
        className: 'od-payment-error-manager-list-item odf-pl-xs',

        render: function() {
            $(this.el).html(this.model.attributes.description);

            return this;
        },
    });

    return Odigeo.View.extend({

        selectors: {
            errorsContainer: '.errors_container',
            paymentmanagerError: '.paymentmanager_error',
        },

        afterBindCollection: function() {
            this.listenTo(this.collection, 'add', function(errorModel) {
                this.appendError(errorModel);
            }, this);
            this.listenTo(this.collection, 'reset', function() {
                this.cleanErrors();
            }, this);
        },

        appendError: function(errorModel) {
            var errorItemView = new ErrorItemView({
                model: errorModel,
            });
            this.$cachedSelectors.errorsContainer.append(this.getDom(errorItemView));
        },

        getDom: function(view) {
            return view.render().el;
        },

        cleanErrors: function() {
            this.$cachedSelectors.paymentmanagerError.addClass('odf-hidden');
            this.$cachedSelectors.errorsContainer.html('');
        },

        getContainerTopPosition: function() {
            this.$cachedSelectors.paymentmanagerError.toggleClass('odf-hidden');
            return this.$cachedSelectors.paymentmanagerError.offset().top - 10 + 'px';
        },
    });
}());
